<div khA11yDialog>
  <div class="modal-header" *ngIf="title">
    <div khA11yLabelSource class="label-name">{{title}}</div>
    <button class="modal-close-x" (click)="close()" [khA11yLabel]="'A11Y_LABEL.CLOSE' | translate" type="button"><fa-icon khA11yHidden [icon]="closeIcon"></fa-icon></button>
  </div>
  <div class="modal-body p-0">
    <kh-video-with-events [videoId]="videoId"></kh-video-with-events>
    
    <div class="p-3" *ngIf="description" [textContent]="description"></div>

  </div>
</div>
